import Box from "@mui/material/Box";
import GenericFormField from "./GenericFormField";
import { FormContainer, GenericFormRoot } from "styles/formStyleComponents";

const GenericForm = ({
  fields = [],
  sections = null,
  values = {},
  onChange,
  onFieldBlur,
  errors = {},
  showBorder = true,
  renderFieldWrapper = null,
}) => {
  const handleFieldChange = (name, value) => {
    if (onChange) {
      onChange(name, value);
    }
  };

  const renderField = (field, index) => {
    const fieldElement = (
      <GenericFormField
        key={field.name || index}
        field={field}
        value={values[field.name]}
        allValues={values}
        onChange={handleFieldChange}
        onFieldBlur={onFieldBlur}
        error={errors[field.name]}
        errors={errors}
      />
    );

    if (renderFieldWrapper && field.wrapperProps) {
      return renderFieldWrapper(field, fieldElement, field.wrapperProps);
    }

    return fieldElement;
  };

  const content = sections ? (
    <>
      {sections.map((section, sectionIndex) => {
        const sectionContent = (
          <>
            {!section.wrapper && section.title && section.renderTitle && section.renderTitle(section.title)}
            {section.fields.map((field, fieldIndex) => {
              let fieldElement = renderField(field, fieldIndex);
              if (section.fieldWrapper) {
                fieldElement = section.fieldWrapper(fieldElement, field, fieldIndex);
              }
              return fieldElement;
            })}
          </>
        );
        const Wrapper = section.wrapper;
        return Wrapper ? (
          <Wrapper key={sectionIndex}>{sectionContent}</Wrapper>
        ) : (
          <Box key={sectionIndex}>{sectionContent}</Box>
        );
      })}
    </>
  ) : (
    <Box>
      {fields.map((field, index) => renderField(field, index))}
    </Box>
  );

  const formBody = <GenericFormRoot>{content}</GenericFormRoot>;

  if (showBorder) {
    return (
      <FormContainer variant="outlined" showBorder={showBorder}>
        {formBody}
      </FormContainer>
    );
  }

  return formBody;
};

export default GenericForm;
